import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { CreateProfilRemisePage } from "@/features/ventes/components/tarifs/CreateProfilRemisePage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/remises/create")({
  loader: requirePermission(TARIF_PERMISSIONS.PROFILS_CREATE),
  staticData: {
    title: "Nouveau profil de remise",
    showInBreadcrumb: true,
  },
  component: CreateProfilRemisePage,
});
